import type { ReactNode, RefObject, UIEventHandler } from "react"
import "./TaskThreadViewport.css"

export const THREAD_VIEWPORT_LIVE_EDGE_THRESHOLD_PX = 32

export function TaskThreadViewport({
    children,
    onScroll,
    viewportRef,
}: {
    children: ReactNode
    onScroll: UIEventHandler<HTMLDivElement>
    viewportRef: RefObject<HTMLDivElement>
}) {
    const handleScroll: UIEventHandler<HTMLDivElement> = (event) => {
        const viewport = event.currentTarget
        const atLiveEdge = viewport.scrollHeight - viewport.scrollTop - viewport.clientHeight <= THREAD_VIEWPORT_LIVE_EDGE_THRESHOLD_PX
        viewport.dataset.threadLiveEdge = atLiveEdge ? "true" : "false"
        onScroll(event)
    }

    return (
        <div
            ref={viewportRef}
            className="task-thread-viewport h-full w-full overflow-x-hidden overflow-y-auto pb-56 pt-11"
            data-thread-live-edge="true"
            onScroll={handleScroll}
        >
            {children}
            <div aria-hidden="true" className="task-thread-scroll-anchor" />
        </div>
    )
}
